import React, { useEffect, useState } from 'react';
import { Card, Table, Tag, Alert, Descriptions, Spin, Result, Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { apiFetch, formatDateTime } from '../api';

const Health: React.FC = () => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await apiFetch<any>('/system/health'));
    } catch (e: any) {
      setError(e.message || 'Не удалось загрузить состояние');
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  if (error) {
    return <Result status="warning" title="Не удалось загрузить состояние" subTitle={error}
      extra={<Button type="primary" onClick={load}>Повторить</Button>} />;
  }
  if (loading || !data) return <Spin style={{ display: 'block', marginTop: 80 }} />;

  const alertColor = (lvl: string) => (lvl === 'error' ? 'error' : lvl === 'warning' ? 'warning' : 'info');

  const brandCols = [
    { title: 'Бренд', dataIndex: 'name', key: 'name' },
    { title: 'Активен', dataIndex: 'is_active', key: 'is_active', render: (v: boolean) => (v ? <Tag color="green">да</Tag> : <Tag>нет</Tag>) },
    { title: 'IG токен', dataIndex: 'has_ig_token', key: 'ig', render: (v: boolean) => (v ? <Tag color="green">есть</Tag> : <Tag>нет</Tag>) },
    { title: 'FB токен', dataIndex: 'has_fb_token', key: 'fb', render: (v: boolean) => (v ? <Tag color="green">есть</Tag> : <Tag>нет</Tag>) },
    { title: 'Последняя проверка', dataIndex: 'last_checked_at', key: 'lc', render: (v?: string) => formatDateTime(v) },
    { title: 'Постов', dataIndex: 'posts', key: 'posts' },
    { title: 'Комментариев', dataIndex: 'comments', key: 'comments' },
    { title: 'Ошибка', dataIndex: 'last_error', key: 'err', render: (v?: string) => (v ? <Tag color="red">{v.slice(0, 80)}</Tag> : <span style={{ color: '#aaa' }}>—</span>) },
  ];

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ReloadOutlined />} onClick={load}>Обновить</Button>
      </Space>

      {data.alerts.length > 0 ? (
        <Card title={`Алерты (${data.alerts.length})`} style={{ marginBottom: 16 }}>
          {data.alerts.map((a: any, i: number) => (
            <Alert
              key={i}
              type={alertColor(a.level)}
              showIcon
              style={{ marginBottom: 8 }}
              title={`${a.brand}: ${a.message}`}
            />
          ))}
        </Card>
      ) : (
        <Alert type="success" showIcon title="Проблем не обнаружено" style={{ marginBottom: 16 }} />
      )}

      <Card title="Планировщик" style={{ marginBottom: 16 }}>
        <Descriptions column={3} size="small">
          <Descriptions.Item label="Включён">{data.scheduler.enabled ? 'да' : 'нет'}</Descriptions.Item>
          <Descriptions.Item label="Опрос, сек">{data.scheduler.interval_seconds}</Descriptions.Item>
          <Descriptions.Item label="Продление токенов, сек">{data.scheduler.token_refresh_seconds}</Descriptions.Item>
          <Descriptions.Item label="Бренды">{data.totals.brands}</Descriptions.Item>
          <Descriptions.Item label="Правила">{data.totals.rules}</Descriptions.Item>
          <Descriptions.Item label="Посты">{data.totals.posts}</Descriptions.Item>
          <Descriptions.Item label="Комментарии">{data.totals.comments}</Descriptions.Item>
          <Descriptions.Item label="Время сервера (UTC)">{data.server_time_utc}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Бренды">
        <Table columns={brandCols} dataSource={data.brands} rowKey="id" pagination={false} size="small" scroll={{ x: 'max-content' }} />
      </Card>
    </>
  );
};

export default Health;
